export default __webpack_public_path__ + "static/media/map_placeholder.36d1f795.png";